export function nid(prefix = ""): string {
    // short deterministic-ish local IDs
    return prefix + Math.random().toString(36).slice(2, 8);
}